<template>
  <div id="club-hotel" class="club-hotel flex flex-col app-page-wrapper absolute">
    <menu-component menu-type="club-hotel" :title="$t('club.hotel')">
      <app-icon
        v-tippy="{
          theme: 'WSM',
          content: $t('club.clubEmployeeDesc'),
          placement: 'left',
          maxWidth: '62rem',
        }"
        icon-name="info-70"
        class="modal-title-icon"
      />
    </menu-component>
    <section class="w-full h-full safe-area">
      <clubs-building-employees building-type="hotel" />
    </section>
  </div>
</template>

<script lang="ts">
import ClubsBuildingEmployees from '@/components/Club/ClubsBuildingEmployees.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ClubsHotel',
  components: {
    ClubsBuildingEmployees,
  },
})
</script>
